import PropTypes from "prop-types";

import { ImgixNextImage as Image } from "@components/imgixNextImage";
import { withSave } from "@components/_hocs/withSave";
import { LP_URL } from "@constants/lpUrl";
import { tagular } from "@cohesion/tagular";

function Card({ featuredImage = null, date, readTime, title, tags, slug }) {
  return (
    <article>
      {featuredImage && (
        <Image
          className="rounded"
          src={featuredImage?.url}
          alt={featuredImage?.alt}
          width={500}
          height={300}
          imgixParams={{ w: 500, h: 300, fit: "crop" }}
        />
      )}

      <div className="py-2">
        <span className="text-sm font-semibold text-black-300">
          {tags[0]?.title}
        </span>

        <a
          href={`${LP_URL}/articles/${slug}`}
          className="my-2 no-underline"
          target="_blank"
          onClick={() => {
            tagular("click", {
              actionOutcome: "INTERNALLINK",
              outboundUrl: `${LP_URL}/articles/${slug}`,
              webElement: {
                elementType: "LINK",
                location: "ITINERARYDAY",
                name: "ARTICLE",
                position: "0",
                text: title,
              },
            });
          }}
          rel="noreferrer"
        >
          <h4 className="text-lg font-semibold text-black line-clamp-2">
            {title}
          </h4>
        </a>

        {date && (
          <p className="text-sm text-black-300">
            {date} &bull; {readTime} Min read
          </p>
        )}
      </div>
    </article>
  );
}

Card.propTypes = {
  date: PropTypes.string.isRequired,
  featuredImage: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
  readTime: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string.isRequired })
  ).isRequired,
  slug: PropTypes.string.isRequired,
};

export const ArticleCard = withSave(Card);
